import { render, staticRenderFns } from "./ClassBuilder.vue?vue&type=template&id=621b5a12"
import script from "./ClassBuilder.vue?vue&type=script&lang=js"
export * from "./ClassBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports